// extracted by mini-css-extract-plugin
export default {"burger":"mobileMenu-module__burger__bowYF"};